let isCaptchaLoaded = false;
let loadPromise = null; // Для предотвращения множественных загрузок

/**
 * Загружает Google reCAPTCHA один раз
 * @returns {Promise<void>} Промис, который резолвится после загрузки скрипта
 */
export const loadRecaptcha = () => {
    // Если уже загружено — возвращаем существующий промис
    if (loadPromise) {
        // console.log('✅ reCAPTCHA уже загружается или загружена');
        return loadPromise;
    }

    // console.log('🚀 Начинаем загрузку Google reCAPTCHA...');

    loadPromise = new Promise((resolve, reject) => {
        // Проверяем, может скрипт уже есть в DOM
        const existingScript = document.querySelector('script[src*="recaptcha/api.js"]');
        if (existingScript) {
            // console.log('⚠️ Скрипт reCAPTCHA уже существует в DOM');
            isCaptchaLoaded = true;
            resolve();
            return;
        }

        const script = document.createElement('script');
        const siteKey = process.env.RECAPTCHA_SITE_KEY;
        
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.defer = true;

        // Обработчики загрузки
        script.onload = () => {
            // console.log('✅ Google reCAPTCHA успешно загружена');
            isCaptchaLoaded = true;
            resolve();
        };

        script.onerror = (error) => {
            console.error('❌ Ошибка загрузки Google reCAPTCHA:', error);
            loadPromise = null; // Сбрасываем, чтобы можно было попробовать снова
            reject(new Error('Не удалось загрузить reCAPTCHA'));
        };

        // ВАЖНО: Добавляем в head, а не в body
        // head всегда доступен, даже если body ещё не готово
        document.head.appendChild(script);
        
        // console.log('📌 Скрипт reCAPTCHA добавлен в DOM:', script.src);
    });

    return loadPromise;
};

/**
 * Проверка готовности reCAPTCHA
 */
export const isRecaptchaReady = () => {
    return isCaptchaLoaded && typeof window.grecaptcha !== 'undefined';
};